<template>
  <dialog-zoomer :visible="visible" >
      <div class="collection-emailer">
        <div class="close-box" v-on:click="handleClose"></div>
        <h3>Email this collection to a colleague or client</h3>
        <div class="padform">
          <label for="toaddress">Send to</label>
          <input type="email" name="toaddress" v-model="toaddress" ref="emailField" />
        </div>
        <div class="padform">
          <label for="message">Message</label>
          <textarea name="message" cols="80" rows="6" v-model="message"></textarea>
        </div>
        <div class="button-panel">
          <small-button large v-on:click="handleSend">Send</small-button>
        </div>
      </div>
    </dialog-zoomer>
</template>

<script>

import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'
import '@/css/my-area.css'
// this is always going to be emailing the current likes, so it should be easy

export default {
  components: {
    DialogZoomer
  },
  props: {
    visible: Boolean
  },
  data () {
    return {
      toaddress: '',
      message: ''
    }
  },
  methods: {
    handleSend() {
      if(!this.$k.validEmail(this.toaddress)) {
        alert('Email must be valid')
        return
      }
      this.$emit('send', { email: this.toaddress, message: this.message})
    },
    handleClose() {
      this.$emit('close')
    }
  }
}
</script>

<style>
.collection-emailer{
  background-color:#fff;
  padding:45px;
}
</style>